import PropTypes from 'prop-types';
import { awaitRequests, promise } from '../../../helpers';
import { firebaseUpdate } from '../firebase';
import { getBooks, saveBookFiles } from './index';

const updateBook = ({ data, docId, where, uploadList }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(firebaseUpdate({ collection: 'books', docId: id, data: d }));

        // -- after update
        const afterUpdate = item => {
            const reqs = [];

            // save book files
            reqs.push(dispatch(saveBookFiles({ item, uploadList })));

            return awaitRequests(reqs).then(() => promise(item));
        };

        // -- single update
        if (docId && data) {
            return update(data, docId).then(updatedItem => afterUpdate(updatedItem));
        }

        // -- multiple update
        if (where && data) {
            return dispatch(getBooks({ where })).then(items => {
                return awaitRequests(items.map(item => update(data, item.id).then(updatedItem => afterUpdate(updatedItem))));
            });
        }

        return promise();
    };
};

updateBook.propTypes = {
    uploadList: PropTypes.array,
};

updateBook.defaultProps = {
    uploadList: [],
};

export default updateBook;
